export const fullDateFormat: string = 'MMM dd, yyyy';
